export const colorNameMap = {
    yellow: new Uint8Array([0xff, 0xff, 0]),
    red: new Uint8Array([0xff, 0, 0]),
    darkRed: new Uint8Array([0xa0, 0, 0]),
    bgBlue: new Uint8Array([0, 0, 0xad]),
    coral: new Uint8Array([0xd6, 0x98, 0xa5]),
    uplinkTimeout: new Uint8Array([0xb0, 0x6a, 0x42]),
    buttonRed: new Uint8Array([0xbe, 0x58, 0x38]),
    lightCyan: new Uint8Array([0, 0xff, 0xff]),
    cyan: new Uint8Array([0, 0xa0, 0xa0]),
    mediumGreen: new Uint8Array([0, 0xad, 0]),
    green: new Uint8Array([0, 0xff, 0]),
    orange: new Uint8Array([0xdc, 0x7a, 0x59]),
    counterGreen: new Uint8Array([0, 0x90, 0]),
    lightGrey: new Uint8Array([0xd0, 0xd0, 0xd0]),
    grey: new Uint8Array([0xad, 0xad, 0xad]),
    mediumGrey: new Uint8Array([0x80, 0x80, 0x80]),
    darkGrey: new Uint8Array([0x57, 0x57, 0x57]),
    veryDarkGrey: new Uint8Array([0x40, 0x40, 0x40]),
    white: new Uint8Array([0xff, 0xff, 0xff]),
    black: new Uint8Array([0, 0, 0]),
    brown: new Uint8Array([0x88, 0x44, 0x44]),
    commandActiveBrown: new Uint8Array([0xad, 0x3a, 0x25]),
};
export const baseBorderColor = colorNameMap.grey;
//# sourceMappingURL=colorNameMap.js.map